import React from "react";
/* -------- packages -------- */
import PropTypes from 'prop-types';
import { Modal, ModalBody } from "reactstrap";
/* -------- ------- -------- */

import DynamicForm from './Form';


const DynamicFormModal = ({ show, onClose, initialValues, fields, editFunction }) => {
  return (
    <Modal size="md" isOpen={show} toggle={onClose} centered={true}>
      <div className="modal-content">
        <ModalBody>
          <DynamicForm
            fields={fields} 
            initialValues={(initialValues || {})}
            editFunction={editFunction}
            linkList={'/contacts'}
            handleCancelFunction={onClose}
            handleAfterSubmit={onClose}
          />
        </ModalBody>
      </div>
    </Modal>
  );
};

DynamicFormModal.propTypes = {
  onClose: PropTypes.func,
  show: PropTypes.any
};

export default DynamicFormModal;
